export default __webpack_public_path__ + "static/media/deleteupload.b7fa508f.svg";